import _asyncToGenerator from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js";
import EventEmitter from "eventemitter3";
import { JsonRpcProvider } from "@walletconnect/jsonrpc-provider";
import { HttpConnection } from "@walletconnect/jsonrpc-http-connection";
import { getRpcUrl, signingMethods } from "@walletconnect/utils";
import { SignerConnection } from "@walletconnect/signer-connection";

var WalletConnectProvider = /*#__PURE__*/function () {
  function WalletConnectProvider(opts) {
    _classCallCheck(this, WalletConnectProvider);

    this.events = new EventEmitter();
    this.rpc = {
      infuraId: opts === null || opts === void 0 ? void 0 : opts.infuraId,
      custom: opts === null || opts === void 0 ? void 0 : opts.rpc
    };
    this.signer = new JsonRpcProvider(new SignerConnection(opts));
    var chainId = this.signer.connection.chainId || (opts === null || opts === void 0 ? void 0 : opts.chainId) || 1;
    this.http = this.setHttpProvider(chainId);
    this.registerEventListeners();
  }

  _createClass(WalletConnectProvider, [{
    key: "connected",
    get: function get() {
      return this.signer.connection.connected;
    }
  }, {
    key: "connector",
    get: function get() {
      return this.signer.connection.connector;
    }
  }, {
    key: "accounts",
    get: function get() {
      return this.signer.connection.accounts;
    }
  }, {
    key: "chainId",
    get: function get() {
      return this.signer.connection.chainId;
    }
  }, {
    key: "rpcUrl",
    get: function get() {
      var _a;

      return ((_a = this.http) === null || _a === void 0 ? void 0 : _a.connection).url || "";
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = args.method;
                _context.next = _context.t0 === "eth_requestAccounts" ? 3 : _context.t0 === "eth_accounts" ? 6 : _context.t0 === "eth_chainId" ? 7 : 8;
                break;

              case 3:
                _context.next = 5;
                return this.connect();

              case 5:
                return _context.abrupt("return", this.signer.connection.accounts);

              case 6:
                return _context.abrupt("return", this.signer.connection.accounts);

              case 7:
                return _context.abrupt("return", this.signer.connection.chainId);

              case 8:
                return _context.abrupt("break", 9);

              case 9:
                if (!signingMethods.includes(args.method)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", this.signer.request(args));

              case 11:
                if (!(typeof this.http === "undefined")) {
                  _context.next = 13;
                  break;
                }

                throw new Error("Cannot request JSON-RPC method (".concat(args.method, ") without provided rpc url"));

              case 13:
                return _context.abrupt("return", this.http.request(args));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "sendAsync",
    value: function sendAsync(args, callback) {
      this.request(args).then(function (response) {
        return callback(null, response);
      }).catch(function (error) {
        return callback(error, undefined);
      });
    }
  }, {
    key: "enable",
    value: function () {
      var _enable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var accounts;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.request({
                  method: "eth_requestAccounts"
                });

              case 2:
                accounts = _context2.sent;
                return _context2.abrupt("return", accounts);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function enable() {
        return _enable.apply(this, arguments);
      }

      return enable;
    }()
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.signer.connection.connected) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.signer.connect();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.signer.connection.connected) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.signer.disconnect();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "isWalletConnect",
    get: function get() {
      return true;
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this = this;

      this.signer.connection.on("accountsChanged", function (accounts) {
        _this.events.emit("accountsChanged", accounts);
      });
      this.signer.connection.on("chainChanged", function (chainId) {
        _this.http = _this.setHttpProvider(chainId);

        _this.events.emit("chainChanged", chainId);
      });
      this.signer.on("disconnect", function () {
        _this.events.emit("disconnect");
      });
    }
  }, {
    key: "setHttpProvider",
    value: function setHttpProvider(chainId) {
      var rpcUrl = getRpcUrl(chainId, this.rpc);
      if (typeof rpcUrl === "undefined") return undefined;
      var http = new JsonRpcProvider(new HttpConnection(rpcUrl));
      return http;
    }
  }]);

  return WalletConnectProvider;
}();

export default WalletConnectProvider;